import { Button } from '@popsure/dirty-swan';
import { Link } from 'react-router-dom';

import { useSafeTranslation } from '../../../../shared/i18n';
import emailSent from '../../assets/feathers.svg';
import styles from './Confirm.module.scss';

export const ConfirmLinkExpired = () => {
  const { t } = useSafeTranslation();

  return (
    <div
      className={`d-flex ai-center jc-center fd-column ${styles.linkExpiredContainer}`}
    >
      <img className="mb16" src={emailSent} alt="Link expired" />
      <h1 className="p-h2">
        {t(
          'updateEmail.updateConfirmation.linkExpired.title',
          'This link has expired'
        )}
      </h1>
      <div className={`p-p mt8 wmx6 ${styles.linkExpiredDescription}`}>
        {t(
          'updateEmail.updateConfirmation.linkExpired.description',
          'For security reasons, these links are only valid temporarily. Luckily, you can request a new one.'
        )}{' '}
      </div>
      <Button className="wmn3 mt24" as={Link} to="/me/account-settings">
        {t(
          'updateEmail.updateConfirmation.goToMyAccount.text',
          'Go to my account'
        )}
      </Button>
    </div>
  );
};
